import {
    anyOrderAttendeesTicketClassHasMultipleDeliveryMethods,
    anyOrderAttendeesTicketClassHasShipping,
} from '../../../utils/deliveryMethod';

export const shouldShowDeliveryMethodPage = (attendees) => {
    const hasMultipleDeliveryMethods =
        anyOrderAttendeesTicketClassHasMultipleDeliveryMethods(attendees);
    const hasShippingDeliveryMethod =
        anyOrderAttendeesTicketClassHasShipping(attendees);

    return hasMultipleDeliveryMethods || hasShippingDeliveryMethod;
};
